import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How is the hair sourced?", a: "Every bundle, frontal and closure in our house is premium raw donor hair, ethically sourced from single donors. No synthetic blends — ever." },
  { q: "Can I dye and heat-style my hair?", a: "Yes. Our hair takes colour and heat beautifully. We always recommend a professional colourist when going lighter than honey blonde." },
  { q: "How long does delivery take?", a: "UK Standard: 3–5 business days. UK Express: 1–2 business days. International orders ship via DHL Express, typically 3–7 business days." },
  { q: "Do you ship to Nigeria and the rest of Africa?", a: "Absolutely. We ship worldwide via DHL Express with full tracking. Customs duties are calculated at checkout where applicable." },
  { q: "What is your returns policy?", a: "Unopened, unaltered items can be returned within 14 days for a full refund. See our Returns page for full details." },
  { q: "How do I care for my wig?", a: "Wash with our sulphate-free shampoo, condition deeply, air dry on a mannequin head and store in our satin-lined bonnet. Treat your crown with reverence and it will love you back." },
  { q: "Are wigs pre-plucked and pre-styled?", a: "Yes — every HD lace wig arrives pre-plucked with baby hairs intact, bleached knots, and ready to wear straight from the box." },
];

export default function FAQ() {
  return (
    <div className="bg-[#FFF4E0] min-h-screen" data-testid="faq-page">
      <section className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <div className="overline mb-3">House Notes</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A0F11]">FAQ</h1>
        <p className="text-[#5C4A4D] mt-4">Everything you need to know about the Hair Bu&apos;tik experience.</p>
        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E8D8C8]">
                <AccordionTrigger className="font-serif-display text-xl md:text-2xl text-[#1A0F11] hover:no-underline text-left py-5" data-testid={`faq-q-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C4A4D] leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
